<template>
  <a-card class="mb-3">
    <a-row>
      <a-col :span="24">
        <a-steps :current="step" :status="status">
          <template v-for="(state, index) in states" :key="index">
            <a-step :title="state.name" :description="state.date" />
          </template>
        </a-steps>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { ref, toRefs, watch } from 'vue';
import { getTicketStates } from '../../network';

export default {
  name: 'Stepper',
  props: {
    ticketType: {
      type: String,
      default: 'alta'
    },
    state: {
      type: String,
      default: 'creado'
    },
    stateDates: {
      type: Object,
      default: {},
      required: false
    }
  },
  setup(props) {
    const type = toRefs(props, 'ticketType');
    const state = toRefs(props, 'state');

    const step = ref(0);
    const status = ref('process');

    // Acá valido qué tipo de ticket es para poner los estados en el stepper
    // Por ejemplo estos serían los estados por ticket
    //         ALTA : Creado, revisión bewell, revisión aseguradora, ejecutado, cancelado
    //         BAJA : Creado, (revisión bewell), revisión aseguradora, ejecutado, cancelado
    // MODIFICACION : Creado, revisión aseguradora, ejecutado, cancelado

    const states = ref([]);
    const filteredStates = ref([]);

    getTicketStates().then((response) => {
      filteredStates.value = response.data.filter((s) =>
        [1, 7, 8, 3].includes(s.id)
      );
    });

    const createSteps = () => {
      const stateCreated = filteredStates.value.find((s) => s.id === 1); // CREADO
      const stateBewell = filteredStates.value.find((s) => s.id === 7); // EN CORREDORA
      const stateInsurance = filteredStates.value.find((s) => s.id === 8); // EN ASEGURADORA
      const stateExecuted = filteredStates.value.find((s) => s.id === 3); // EJECUTADO
      let statesData = [
        {
          state: 'creado',
          name: stateCreated?.fullTag || stateCreated?.tag || '',
          date: props.stateDates.creado != '' ? props.stateDates.creado : ''
        },
        {
          state: 'revision_aseguradora',
          name: stateInsurance?.fullTag || stateInsurance?.tag || '',
          date:
            props.stateDates.revision_aseguradora != ''
              ? props.stateDates.revision_aseguradora
              : ''
        },
        {
          state: 'ejecutado',
          name: stateExecuted?.fullTag || stateExecuted?.tag || '',
          date:
            props.stateDates.ejecutado != '' ? props.stateDates.ejecutado : ''
        }
      ];

      if (
        (props.ticketType === 'alta' || props.ticketType === 'baja') &&
        stateBewell
      ) {
        statesData.splice(1, 0, {
          state: 'revision_bewell',
          name: stateBewell.fullTag || stateBewell.tag || '',
          date:
            props.stateDates.revision_bewell != ''
              ? props.stateDates.revision_bewell
              : ''
        });
      }

      // Filter out skipped middle states: steps before the current state
      // that have no date (were omitted from the actual ticket flow).
      // Keep future states (after current, even without dates).
      const currentIdx = statesData.findIndex((s) => s.state === props.state);
      if (currentIdx > 0) {
        statesData = statesData.filter((s, idx) => {
          const hasDate = s.date !== '' && s.date !== undefined;
          if (hasDate) return true;
          if (idx >= currentIdx) return true; // future state, keep
          return false; // skipped middle state, remove
        });
      }

      states.value = statesData;
      createState(props.state);
    };

    const createState = (value) => {
      for (let i = 0; i < states.value.length; i += 1) {
        const element = states.value[i];
        if (value === element.state) {
          step.value = i;
        }
      }
    };

    const cancelStep = () => {
      status.value = 'error';
    };
    const finishStep = () => {
      status.value = 'process';
      status.value = 'finish';
    };

    const uncalcenStep = () => {
      status.value = 'process';
    };

    // Re-run createSteps when the states API resolves so labels are populated
    watch(filteredStates, () => {
      createSteps();
    });

    watch(
      () => props.ticketType,
      () => {
        createSteps();
      }
    );

    watch(
      () => props.state,
      (val) => {
        createState(val);
      }
    );

    watch(
      () => props.stateDates,
      (newVal) => {
        // Este usar para crear la parte de cambias las fechas cuando se cancela o ejecuta
        for (let i = 0; i < states.value.length; i += 1) {
          const element = states.value[i];

          if (element.state in newVal) {
            states.value[i].date = newVal[element.state];
          }
        }

        createSteps();
      },
      { deep: true }
    );

    createSteps();
    createState(props.state);

    return {
      type,
      states,
      // TODO: ARREGLAR VARIABLES DUPLICADAS
      // eslint-disable-next-line vue/no-dupe-keys
      state,
      step,
      status,
      cancelStep,
      finishStep,
      uncalcenStep
    };
  }
};
</script>
